// extracted by mini-css-extract-plugin
module.exports = {"comp_box":"comp_box___3B65X","cycle_item":"cycle_item___2mXSI","body_text":"body_text___3v9_f"};